import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg width="122" height="69" viewBox="0 0 122 69" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter03_d)">
            <path d="M16.9433 10H10V16.9433H16.9433V10Z" fill="white"/>
            <path d="M69.5143 13.1738H13.4717V13.9673H69.5143V13.1738Z" fill="white"/>
            <path d="M30.9297 24.085H23.9863V31.0283H30.9297V24.085Z" fill="white"/>
            <path d="M83.5006 27.1597H27.458V27.9532H83.5006V27.1597Z" fill="white"/>
            <path d="M45.0146 38.0708H38.0713V45.0141H45.0146V38.0708Z" fill="white"/>
            <path d="M97.5856 41.146H41.543V41.9395H97.5856V41.146Z" fill="white"/>
            <path d="M59 52.0566H52.0566V59H59V52.0566Z" fill="white"/>
            <path d="M111.572 55.1313H55.5293V55.9249H111.572V55.1313Z" fill="white"/>
        </g>
        <defs>
            <filter id="filter03_d" x="0" y="0" width="121.572" height="69" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                <feOffset/>
                <feGaussianBlur stdDeviation="5"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.101961 0 0 0 0 0.596078 0 0 0 0 1 0 0 0 1 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
            </filter>
        </defs>
    </svg>
)
